/**************************************************
 * Nombre:       Nosotros_Portada.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useContext} from "react";
import {contexApp} from "../../../App";
import {useNavigate} from "react-router";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import nosotros from '../../../Recursos/foto_nosotros.png'
import andres from '../../../Recursos/foto_andres.png'
import {theme} from "../../../Tema";
import {FiberManualRecord} from "@mui/icons-material";


const Nosotros_Portada = () => {
    const cData = useContext(contexApp)
    const {sCell, sTab, masSM} = useResponsive()
    const navigate = useNavigate();

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#EAEEF0',
            }}
        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, pt: 6, pb: 3}}
            >


                <Grid container size={{xs: 12, sm: 5, md: 5}} sx={{justifyContent: 'flex-start'}}>
                    <img src={nosotros} width={'100%'} height={'auto'}/>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 7, md: 7}}
                    sx={{color: theme.palette.primary.main, px: sCell ? 1 : 8}}
                >


                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: sCell ? 4 : 0}}>
                        <Typography sx={{fontSize: 16, fontWeight: 600}}>NOSOTROS</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{
                            fontSize: !masSM ? 32 : 40,
                            fontWeight: 600,
                            lineHeight: 1,
                            textAlign: sCell ? 'center' : sTab ? 'left' : 'center'
                        }}>Dos Visiones, Un Solo
                            Espíritu <span style={{fontWeight: 800}}>Oaxaqueño</span></Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                        <Typography sx={{fontSize: 16, fontWeight: 400}}>
                            En Generación Mezcal, somos el puente entre la tradición sagrada de Oaxaca y el mundo.
                            Nuestra esencia une dos fuerzas: el rigor artesanal de la Sra. Reyna Aquino, quien supervisa
                            cada fase desde el cultivo hasta la destilación para honrar un legado familiar, y la visión
                            estratégica de Andrés Arteaga, quien profesionaliza la industria a través de tecnología y
                            logística.
                            <br/>
                            <br/>
                            Juntos, garantizamos que la excelencia de nuestro mezcal llegue a cualquier rincón de mexico
                            con total autenticidad, transparencia y puntualidad.
                        </Typography>
                    </Grid>

                </Grid>

                {sCell &&
                    <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'center', mt: 6}}>
                        <img src={andres} width={'80%'} height={'auto'}/>
                    </Grid>
                }

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 6, md: 6}}
                    sx={{color: theme.palette.primary.main, mt: 8}}
                    spacing={1}
                >

                    {items.map((it, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>

                            <Typography sx={{fontWeight: 400}}>
                                <FiberManualRecord
                                    sx={{
                                        fill: theme.palette.primary.main,
                                        width: 18,
                                        height: 18,
                                        mt: 0.5,
                                        mb: -0.5,
                                        pr: 1
                                    }}/>
                                {it}</Typography>
                        </Grid>
                    ))}

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 3}}>
                        <Button sx={{px: 8}}>Contactos</Button>
                    </Grid>

                </Grid>

                {!sCell &&
                    <Grid container size={{xs: 12, sm: 12, md: 6}}
                          sx={{justifyContent: 'flex-end', pr: 20, mt: -4, pb: 8}}>
                        <img src={andres} width={'50%'} height={'auto'}/>
                    </Grid>
                }

            </Grid>

        </Grid>
    )

}
export default Nosotros_Portada

const items = [
    'Herencia Familiar Auténtica',
    'Expansión Global Estratégica',
    'Supervisión Maestra en Origen',
    'Trazabilidad Tecnológica Garantizada',
    'Conexión Profunda con la Tierra Oaxaqueña',
    'Digitalización y Profesionalización',
    'Compromiso con la Excelencia Artesanal',
    'Logística Eficiente y Puntual'
]